// extracted by css-extract-rspack-plugin
export default {"title":"title--Z9FeLyEY3sZrwn2k","linkVisited":"link-visited--L3w8V1qE8bIGgDTI","icon":"icon--YxOaZ6bE0tPFx7Qc"};